/* tempexp_18086-start */
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { ReferralUserModalProps } from './ReferralUserModal';

export const renderReferralUserModal = ({ onClose, ...data }: ReferralUserModalProps) =>
    openPopupHelper({ popupName: popupNames.REFERRAL_USER_MODAL, data, onClose });

export const closeReferralUserModal = () => closePopupHelper(popupNames.REFERRAL_USER_MODAL);

/* tempexp_18086-end */
